export enum SheetId {
    // Containers
    Inbox = 'Inbox',
    Document = 'Document',
    Notifications = 'Notifications',
    Sharing = 'Sharing',

    // Menu
    CanvasContextMenu = 'CanvasContextMenu',
    QuickAddMenu = 'QuickAddMenu',
    AccountSettings = 'AccountSettings',
    BoardEditorPermission = 'BoardEditorPermission',
    GestureShakeMenu = 'GestureShakeMenu',

    // Tools
    ContextMenuTool = 'ContextMenuTool',
    TextStyleRichTextTool = 'TextStyleRichTextTool',
    ColorTool = 'ColorTool',
    IconTool = 'IconTool',
    ReactionTool = 'ReactionTool',
    TaskItemReactionTool = 'TaskItemReactionTool',
    TaskItemLabelsTool = 'TaskItemLabelsTool',
    LabelsTool = 'LabelsTool',
    LabelActionsTool = 'LabelActionsTool',
    LabelEditTool = 'LabelEditTool',
    LabelColorTool = 'LabelColorTool',
    LabelDeleteTool = 'LabelDeleteTool',
    ElementReactionTool = 'ElementReactionTool',
    DueDateTool = 'DueDateTool',
    AssignmentTool = 'AssignmentTool',
    SearchTool = 'SearchTool',
    ColorDisplayTool = 'ColorDisplayTool',
    LineWeightTool = 'LineWeightTool',
    ImageTool = 'ImageTool',
    TableCellColorTool = 'TableCellColorTool',
    TableTextStyleRichTextTool = 'TableTextStyleRichTextTool',
    TableCellAlignmentTool = 'TableCellAlignmentTool',
    TableFormulaTool = 'TableFormulaTool',
    TableDatePickerTool = 'TableDatePickerTool',
    TableCellTypeTool = 'TableCellTypeTool',
    TableCellTypeFormatTool = 'TableCellTypeFormatTool',
    TableContextMenuTool = 'TableContextMenuTool',
    InsertMenuTool = 'InsertMenuTool',
    InsertBoardLinkTool = 'InsertBoardLinkTool',

    // Popups
    BillingAlertPopup = 'BillingAlertPopup',
    Auth = 'Auth',
    SegmentPicker = 'SegmentPicker',
    EmailVerificationSuccess = 'EmailVerificationSuccess',
    EmailVerificationRequired = 'EmailVerificationRequired',
    TemplatePicker = 'TemplatePicker',
    CommentThread = 'CommentThread',

    // Modals
    RouteModal = 'RouteModal',
    Error = 'Error',
    ReportContent = 'ReportContent',
}

/**
 * Flows group related mobile sheets that should behave like a single navigation stack.
 * Only one sheet in a flow can be open at a time, and closing a child sheet restores
 * the previously open sheet in that same flow.
 */
export enum SheetFlowId {
    Labels = 'labels',
    InsertMenu = 'insert-menu',
}

// Sheets on the "..." menu, which reset the toolbar when opened
export const MORE_TOOLS_SHEETS = [SheetId.AccountSettings, SheetId.SearchTool, SheetId.Notifications];

export type SheetConfig = {
    scrollToElementOnOpen?: boolean;
    containsElementEditor?: boolean;
    stayActiveOnLocationChange?: boolean;
    flow?: SheetFlowId;
};

export type SheetCloseOptions = {
    popToSheetId?: SheetId;
    dismissFlow?: boolean;
};

export type SheetOpenOptions = {
    data?: object;
};

type BaseSheetState = {
    active: boolean;
    sheetId: SheetId;
    instanceId?: string;
    activeSnapPoint: number;
    data?: object;
    config?: SheetConfig;
    pendingSheetState?: SheetState;
};

export type ErrorSheetState = {
    sheetId: SheetId.Error;
    activeErrorNoticeId: string;
    data: object | undefined;
} & BaseSheetState;

export type SheetState = BaseSheetState | ErrorSheetState;

export type SheetStateByKey = {
    [sheetKey in string]?: SheetState;
};

export type SheetFlowState = {
    stack: SheetState[];
    pendingSheetState?: SheetState;
};

export type SheetFlowStateById = {
    [flowId in SheetFlowId]?: SheetFlowState;
};

export type SheetReducerState = {
    sheets: SheetStateByKey;
    flows: SheetFlowStateById;
};
